




























import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FormLabelAlign } from '@/store/pages/report/index.d';
const Report = namespace('report');

@Component
export default class Benchmark extends Vue {
  @Prop() private dialogSettingTableVisible!: boolean;
  @Prop() private formLabelAlign!: FormLabelAlign;
  @Prop() private property!: string;
  @Prop() private reportId!: number;
  @Prop() private level!: number;
  @Prop() private fileds!: number;
  @Prop() private label!: string;
  private labelPosition: string = 'left';
  public saveBenchmarks() {
    this.$emit('changedialog', false);
    const benchmarks: any[] = [];
    if (this.formLabelAlign.value1) {
      benchmarks.push(this.formLabelAlign.value1);
    }
    if (this.formLabelAlign.value2) {
      benchmarks.push(this.formLabelAlign.value2);
    }
    if (this.formLabelAlign.value3) {
      benchmarks.push(this.formLabelAlign.value3);
    }
    this.$emit('saveBenchmarks', benchmarks);
  }
}
